import Header from "./header/header";
import Footer from "./footer/footer";
import NavBar from "./nav/nav-bar";
import "./live-call.css";
import { useEffect, useState, useCallback, useRef } from "react";
import { useHistory } from "react-router-dom";
import Service from "./webservice/http";
import ClipLoader from "react-spinners/ClipLoader";
import PulseLoader from "react-spinners/PulseLoader";
import { BiError, BiUserVoice } from "react-icons/bi";
import { RiSignalWifiErrorFill, RiUserVoiceFill } from "react-icons/ri";
import { MdOutlineVerifiedUser } from "react-icons/md";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
// useWebSocket removed - using native WebSocket for two-way call
import reactDom from "react-dom";
import ReactHtmlParser from "react-html-parser";
import useTimer from "easytimer-react-hook";
import { stringSimilarity } from "string-similarity-js";
//import reactDom from "react-dom";
import Notes from "./Notes";
import Dropdown from "rsuite/Dropdown";

import "rsuite/dist/rsuite.min.css";
import { Items } from "./Items";
import DropdownItem from "react-bootstrap/esm/DropdownItem";
import DropdownMenu from "react-bootstrap/esm/DropdownMenu";
import Filter from "./filter";
import { FaFilter } from "react-icons/fa";
import Profiling from "./profiling";
import { BiHistory } from "react-icons/fa";
import Table from "react-bootstrap/Table";
import { FaTimes } from "react-icons/fa";
import { BsCheckLg } from "react-icons/bs";
import data from "./dummydata";
import { useSelector, useDispatch } from "react-redux";
import sidebar, { makeVisible, makeVanish } from "./features/sidebar/sidebar";
import Head from "./sidebar-livecall/head";
import Nav from "./sidebar-livecall/nav";
import Masonry from "react-masonry-css";
import moment from "moment";
import config from "./config";
import { storage } from "./utils/storage";

const LiveCall = () => {
  const currentDate = moment().format("MMM Do YY");
  const history = useHistory();
  const services = new Service();
  const clientName = storage.getItem("client_name");
  const useCase = storage.getItem("usecase");

  const [supportingInfo, setSupportingInfo] = useState(null);
  const [supportingInfoPending, setSupportingInfoPending] = useState();
  const [supportingInfoError, setSupportingInfoError] = useState();
  const [callType, setCallType] = useState("");
  const [product, setProduct] = useState("");
  const [customerID, setCustomerID] = useState("");
  const [activeKey, setActiveKey] = useState("Product");
  const [productDetail, setProductDetail] = useState("");

  // console.log(sidebarVisiblity);

  const agentRelationship = [
    {
      name: "Savings Account",
      check: true,
    },
    {
      name: "Checking Account",
      check: false,
    },
    {
      name: "Personal Loans",
      check: true,
    },
    {
      name: "Mortgages",
      check: false,
    },
    {
      name: "Business Accounts",
      check: false,
    },
    {
      name: "Credit Cards",
      check: true,
    },
    {
      name: "Investment Services",
      check: true,
    },
    {
      name: "Retirement Accounts",
      check: false,
    },
    {
      name: "Trust and Estate Services",
      check: true,
    },
    {
      name: "Safety Deposit Boxes",
      check: false,
    },
    {
      name: "Online Banking Services",
      check: true,
    },
  ];

  const fetchnextdropdown = function () {
    let url = `api/call_quality/manage_full_script/`;
    // if (product) {
    //   url = url + `?product_type=${product}`;
    // }
    // if (productType) {
    //   url = product
    //     ? url + `&product=${productType}`
    //     : url + `?product=${productType}`;
    // }
    services.get(url).then((res) => {
      // console.log("lll", res);
      // setFullScript(res);
      setProductDetail(res);
    });
  };

  useEffect(() => {
    const handleMessage = (event) => {
      // Optional security validation
      // if (event.origin !== "https://loyce-squshiest-axiologically.ngrok-free.dev") return;
      if (
        event.data &&
        typeof event.data === "object" &&
        event.data.type === "REDIRECT"
      ) {
        console.log(
          "React received REDIRECT message. Navigating to:",
          event.data.path,
        );
        const path = event.data.path || "/call-list";
        window.location.href = path;
      }
    };
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  useEffect(() => {
    // fetchProduct();
    fetchnextdropdown();
  }, []);

  useEffect(() => {
    fetchSupportingInfo();
    fetchCI();
  }, []);

  // Listen for REDIRECT messages from the livecall iframe (sent after auto-save)
  useEffect(() => {
    const handleIframeMessage = (event) => {
      if (event.data && event.data.type === "REDIRECT") {
        console.log(
          "[live-call] Received REDIRECT from iframe:",
          event.data.path,
        );
        history.push(event.data.path);
      }
    };
    window.addEventListener("message", handleIframeMessage);
    return () => window.removeEventListener("message", handleIframeMessage);
  }, [history]);

  /**
   * Fetch live call supporting information which are required to process live call
   */
  function fetchSupportingInfo() {
    setSupportingInfoPending(true);
    setSupportingInfo(null);
    services.get("api/call/new_call/").then((res) => {
      // console.log(res);
      setSupportingInfoPending(false);
      if (res == "TypeError: Failed to fetch") {
        setSupportingInfoError("Connection Error");
      } else {
        if (res.code == "token_not_valid") {
          storage.clear();
          history.push("/login");
        }

        setSupportingInfo(res);
        setSupportingInfoError(null);
      }
    });
  }

  const [timer, isTargetAchieved] = useTimer({});
  const [callInitiate, setCallInitiate] = useState(false);
  const [callInitiatePending, setCallInitiatePending] = useState(false);

  const [notes, setNotes] = useState("");
  const [showRelationshipPopup, setShowRelationshipPopup] = useState(false);

  const [notesdata, setNotesData] = useState([
    { Notes: "Cross verify the email" },
    // { Notes: "Complies with data protection regulations" },
    { Notes: "Forgetting security information." },
  ]);

  // console.log(notesdata);
  const handleNotes = function () {
    const newArr = { Notes: notes };
    setNotesData((prevNotes) => [...prevNotes, newArr]);
    setNotes("");
  };

  // useEffect(() => {}, [notesdata]);

  /**
   *
   * @returns Initiate Live Call
   *
   */

  const [socketUrl, setSocketUrl] = useState("wss://livecall.dataklout.ai");
  const [messageHistory, setMessageHistory] = useState([]);
  const socketRef = useRef(null);

  const [transcriptionData, setTranscriptionData] = useState([]);
  const [transcriptionSentiment, setTranscriptionSentiment] = useState([]);
  const [transcriptionEntities, setTranscriptionEntities] = useState([]);

  const [receivingTranscription, setReceivingTranscription] = useState(false);
  const [agentPrompt, setAgentPrompt] = useState(null);
  const [inbound, setInbound] = useState(false);
  const [outbound, setOutbound] = useState(false);
  const [personA, setPersonA] = useState("");
  const [personB, setPersonB] = useState("");

  const lastSpeech = useRef(null);
  const lastSentiment = useRef(null);

  const [sentimentString, setSentiemntString] = useState("");
  const [foundConsumablesInsight, setFoundConsumablesInsight] = useState([]);
  const [audioUrl, setAudioUrl] = useState(null);
  const [callDuration, setCallDuration] = useState(null);
  const [consumablesInsight, setConsumablesInsight] = useState(null);
  const [edit, setEdit] = useState(false);

  const [sidebarVisible, setSidebarVisible] = useState(false);
  const sideBarWidth = sidebarVisible ? 440 : 0;

  const changeSideBarWidth = () => {
    setSidebarVisible(!sidebarVisible);
  };

  const receivingTimeoutRef = useRef(null);

  // Refs to avoid stale closures in WebSocket message handler
  const sentimentStringRef = useRef(sentimentString);
  const transcriptionSentimentRef = useRef(transcriptionSentiment);
  const transcriptionEntitiesRef = useRef(transcriptionEntities);
  const foundConsumablesInsightRef = useRef(foundConsumablesInsight);
  const consumablesInsightRef = useRef(consumablesInsight);

  // Keep refs in sync with state
  useEffect(() => {
    sentimentStringRef.current = sentimentString;
  }, [sentimentString]);
  useEffect(() => {
    transcriptionSentimentRef.current = transcriptionSentiment;
  }, [transcriptionSentiment]);
  useEffect(() => {
    transcriptionEntitiesRef.current = transcriptionEntities;
  }, [transcriptionEntities]);
  useEffect(() => {
    foundConsumablesInsightRef.current = foundConsumablesInsight;
  }, [foundConsumablesInsight]);
  useEffect(() => {
    consumablesInsightRef.current = consumablesInsight;
  }, [consumablesInsight]);

  const handleSocketMessage = (data) => {
    try {
      if (data.event === "interim-transcription") {
        setReceivingTranscription(true);

        if (receivingTimeoutRef.current) {
          clearTimeout(receivingTimeoutRef.current);
        }
        receivingTimeoutRef.current = setTimeout(() => {
          setReceivingTranscription(false);
        }, 3000);

        const track = data.track || "agent";
        const cleanText = data.text.replace(/^\[(agent|customer)\]\s*/i, "");

        setTranscriptionData((prev) => [
          ...prev,
          {
            id: Date.now(),
            text: cleanText,
            track: track,
            sentiment: data.sentiment,
            time: timer.getTimeValues().toString(),
          },
        ]);

        // Use refs to avoid stale closures
        var sentimentArray = [
          ...transcriptionSentimentRef.current,
          data.sentiment,
        ];
        setTranscriptionSentiment(sentimentArray);

        var currentSentimentString = sentimentStringRef.current;
        if (data.sentiment >= 0)
          setSentiemntString(
            currentSentimentString +
              "<p><a style=color:green; font-size:20px;>" +
              timer.getTimeValues().toString() +
              " -  POSITIVE</a></p>",
          );
        else
          setSentiemntString(
            currentSentimentString +
              "<p><a style=color:red; font-size:20px;>" +
              timer.getTimeValues().toString() +
              " -  Negative</a></p>",
          );

        try {
          reactDom.render(
            ReactHtmlParser(sentimentStringRef.current),
            document.getElementById("sentimentDiv"),
          );
        } catch {}

        var ciTemp = [...foundConsumablesInsightRef.current];
        if (data.entities && data.entities.length > 0) {
          var entitiesArray = [...transcriptionEntitiesRef.current];
          for (let i = 0; i < data.entities.length; i++) {
            if (entitiesArray.includes(data.entities[i].name) === false) {
              entitiesArray.push(data.entities[i].name);
              if (consumablesInsightRef.current) {
                consumablesInsightRef.current.map((ci) => {
                  var found = false;
                  for (let j = 0; j < ciTemp.length; j++) {
                    if (ci.keyword === ciTemp[j].keyword) {
                      found = true;
                      break;
                    }
                  }
                  if (found == false)
                    if (
                      data.entities[i].name
                        .toLowerCase()
                        .includes(ci.keyword.toLowerCase())
                    ) {
                      ciTemp.push(ci);
                    }
                });
              }
            }
          }
          setTranscriptionEntities(entitiesArray);
          setFoundConsumablesInsight(ciTemp);
        }

        if (consumablesInsightRef.current) {
          consumablesInsightRef.current.map((ciItem) => {
            if (
              data.text.toLowerCase().includes(ciItem.keyword.toLowerCase())
            ) {
              if (!ciTemp.includes(ciItem)) {
                ciTemp.push(ciItem);
              }
            }
          });
        }

        setFoundConsumablesInsight(ciTemp);

        lastSpeech.current?.scrollIntoView({ behavior: "smooth" });
        lastSentiment.current?.scrollIntoView({ behavior: "smooth" });
      } else if (data.event === "agent-prompt") {
        setAgentPrompt(data.text);
      } else if (data.event === "activity") {
        setReceivingTranscription(false);
        if (
          data.text === "Call Has Ended." ||
          data.text.toLowerCase().includes("ended")
        ) {
          setCallInitiate(false);
          setCallDuration(timer.getTimeValues().toString());
          timer.stop();
          timer.reset();
        }
        try {
          if (data.audio_url) {
            setAudioUrl(data.audio_url);
          }
        } catch {}
        lastSpeech.current?.scrollIntoView({ behavior: "smooth" });
        lastSentiment.current?.scrollIntoView({ behavior: "smooth" });
      }
      lastSpeech.current?.scrollIntoView({ behavior: "smooth" });
      lastSentiment.current?.scrollIntoView({ behavior: "smooth" });
      findIntent();
    } catch (e) {
      console.log("WebSocket message error:", e);
    }
  };

  // Connect WebSocket on mount (same as testing env dashboard)
  // This ensures WS is already open before a call is initiated, so no messages are missed
  useEffect(() => {
    socketRef.current = new WebSocket(socketUrl);

    socketRef.current.onopen = () => {
      console.log("WebSocket connected to", socketUrl);
    };

    socketRef.current.onmessage = (event) => {
      const data = JSON.parse(event.data);
      handleSocketMessage(data);
    };

    socketRef.current.onclose = () => {
      console.log("WebSocket closed");
    };

    socketRef.current.onerror = (error) => {
      console.log("WebSocket error:", error);
    };

    return () => {
      if (socketRef.current) {
        socketRef.current.close();
      }
    };
  }, [socketUrl]);

  const [intent, setIntent] = useState(null);

  function findIntent() {
    var positiveCount = 0;
    var negativeCount = 0;
    var sentimentArray = transcriptionSentiment;
    sentimentArray.map((sentiment) => {
      if (sentiment >= 0) {
        positiveCount++;
      } else {
        negativeCount++;
      }
    });
    if (positiveCount > negativeCount) {
      setIntent("Positive");
    } else if (negativeCount > positiveCount) {
      setIntent("Negative");
    } else {
      setIntent("Neutral");
    }
  }

  const [open, setOpen] = useState(false);

  function fetchCI() {
    services.get("api/live_call/consumables_detail/").then((res) => {
      if (res == "TypeError: Failed to fetch") {
        NotificationManager.warning(
          "Warning",
          "Failed to load consumables insight !!!",
        );
      } else {
        if (res.code == "token_not_valid") {
          storage.clear();
          history.push("/login");
        }
        // console.log(res);
        setConsumablesInsight(res);
      }
    });
  }

  var url = window.location.href;

  const initiateCall = () => {
    if (!personA || !personB) {
      NotificationManager.warning(
        "Warning",
        "Please enter both Person A and Person B numbers.",
      );
      return;
    }

    setCallInitiatePending(true);
    setTranscriptionData([]);
    setTranscriptionSentiment([]);
    setTranscriptionEntities([]);
    setFoundConsumablesInsight([]);
    setSentiemntString("");
    setAgentPrompt(null);
    setIntent(null);

    const callUrl = `https://livecall.dataklout.ai/call?to1=${encodeURIComponent(personA)}&to2=${encodeURIComponent(personB)}`;
    fetch(callUrl, { method: "GET" })
      .then((res) => {
        if (res.ok) {
          NotificationManager.success("Success", "Call Initiated");
          timer.start({});
          setCallInitiatePending(false);
          setCallInitiate(true);
          console.log(
            `Initiating two-way call between ${personA} and ${personB}`,
          );
        } else {
          NotificationManager.error("Error", "Failed to initiate call");
          setCallInitiatePending(false);
        }
      })
      .catch((err) => {
        NotificationManager.error("Error", "Failed to initiate call");
        setCallInitiatePending(false);
        console.error("Failed to start call", err);
      });
  };

  const saveLiveCall = () => {
    var data = {
      customer_id: customerID,
      sentiment: intent,
      transcription: transcriptionData.map((msg) => msg.text),
      call_type_id: callType,
      product_id: product,
      keywords: transcriptionEntities,
      audio_url: audioUrl,
      call_duration: callDuration,
      consumables_insight: foundConsumablesInsight,
    };
    // console.log(data);
    if (
      customerID === "" ||
      intent === "" ||
      transcriptionData.length == 0 ||
      callType === "" ||
      product === "" ||
      callDuration === "" ||
      callDuration === null
    ) {
      NotificationManager.error("Error", "Please Perform Call Properly");
      return;
    }

    if (audioUrl === "" || audioUrl === null) {
      NotificationManager.error(
        "Error",
        "Please wait till we process audio url",
      );
      return;
    }

    services.post("api/live_call/add_new_call/", data).then((res) => {
      if (res == "TypeError: Failed to fetch") {
        NotificationManager.warning(
          "Warning",
          "Please Check your connection once !!!",
        );
      } else {
        if (res.code == "token_not_valid") {
          storage.clear();
          history.push("/login");
        }
        if (res.call_id) {
          NotificationManager.success(
            "Success",
            "Your Call Has been processed !!!",
          );
          setIntent(null);
          setTranscriptionData([]);
          setTranscriptionEntities([]);
          setAudioUrl(null);
          setCallDuration(null);
          setFoundConsumablesInsight([]);
          setSentiemntString("");

          setCallType("");
          setProduct("");
          setCustomerID("");
          fetchSupportingInfo();
        } else {
          NotificationManager.error("Error", res.error);
        }
      }
    });
  };

  useEffect(() => {
    try {
      reactDom.render(
        ReactHtmlParser(sentimentString),
        document.getElementById("sentimentDiv"),
      );
    } catch {}
  }, [sentimentString]);
  // const [sideBarWidth, setSideBarWidth] = useState(0);

  // const changeSideBarWidth = () => {
  //   if (sideBarWidth == 440) {
  //     setSideBarWidth(0);
  //   } else {
  //     setSideBarWidth(440);
  //   }
  // };

  // useEffect(() => {}, [sidebarVisiblity]);

  // console.log(sidebarVisiblity);

  return (
    <div className="dashboard-body ">
      <Header />
      <NavBar />
      {/* <div
        onClick={changeSideBarWidth}
        style={{
          position: "fixed",
          transition: ".5s",
          transitionTimingFunction: "linear",
          top: "30%",
          right: sideBarWidth,
          backgroundColor: "#e9be73",
          color: "white",
          // borderWidth: "2px",
          // boxShadow: "6px 6px 3px #999",
          height: "45px",
          zIndex: "45",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "45px",
          cursor: "pointer",
        }}
      >
        {sideBarWidth > 0 ? (
          <i
            className="fa fa-arrow-right"
            aria-hidden="true"
            style={{ fontSize: "30px" }}
          ></i>
        ) : (
          <i
            className="fa fa-arrow-left"
            aria-hidden="true"
            style={{ fontSize: "30px" }}
          ></i>
        )}
      </div> */}
      <div
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          width: "440px",
          height: "100%",
          backgroundColor: "white",
          transform: sidebarVisible ? "translateX(0)" : "translateX(100%)",
          transition: "transform 0.5s linear",
          zIndex: 40,
          overflowY: "auto",
          boxShadow: "-4px 0 8px rgba(0, 0, 0, 0.2)",
        }}
      >
        <div style={{ padding: "20px" }}>
          <Profiling />
        </div>
      </div>

      <NotificationContainer />

      <div id="test"></div>
      <section className="custom-wrapper-glife">
        {supportingInfo && (
          <div className="container-fluid" style={{ padding: 0 }}>
            <iframe
              src={`https://livecall.dataklout.ai/?token=${encodeURIComponent(storage.getItem("access_token") || "")}`}
              // src={`https://splashy-uncured-simmering.ngrok-free.dev/?token=${encodeURIComponent(storage.getItem("access_token") || "")}`}
              title="Live Call UI"
              style={{
                width: "100%",
                height: "calc(100vh - 120px)",
                border: "none",
                display: "block",
              }}
              allow="microphone; camera; autoplay"
            />
          </div>
        )}

        {supportingInfoPending && (
          <div className="empty-call">
            <ClipLoader color="#2056FF" size="50px" />
          </div>
        )}

        {supportingInfoError && (
          <div className="empty-call">
            <p style={{ fontSize: "25px", color: "#FF8520" }}>
              {supportingInfoError === "Connection Error" && (
                <RiSignalWifiErrorFill />
              )}
              {supportingInfoError !== "Connection Error" && <BiError />}
              {supportingInfoError}
            </p>
          </div>
        )}
      </section>

      <Footer />
    </div>
  );
};
export default LiveCall;
